import { HeadFC, PageProps, graphql } from "gatsby";
import { IGatsbyImageData } from "gatsby-plugin-image";
import React from "react";
import { Card } from "../components/Card";
import GridCol from "../components/GridCol";
import GridContainer from "../components/GridContainer";
import Layout from "../components/Layout";
import { SEO } from "../components/Seo";
import Heading from "../components/Heading";
import { mediaQueries, pxToRem } from "../utils/css-utils";
import { getGatsbyImage } from "../utils/image-utils";
import { css } from "@emotion/react";
import customCover from "../../static/gs-next-js/nextjs-hero.png";

const BlogPage: React.FC<PageProps<Queries.allStrapiBlogPostQueryQuery>> = ({
  data,
}: PageProps<Queries.allStrapiBlogPostQueryQuery>) => {
  const headingStyles = css`
    text-align: center;
    margin-top: 40px;
    margin-bottom: 40px;

    ${mediaQueries.lg} {
      margin-top: 80px;
      margin-bottom: 80px;
    }
  `;

  const margin = css`
    margin-bottom: 40px;
  `;

  let filteredPosts = data.allStrapiBlogPost.edges.filter((post) => {
    return post?.node?.publishedAt !== null;
  });
  
  const customPosts = {
    node: {
      id: "customPost-1",
      url: "setting-up-next-js-on-upsun",
      publishedAt: "13 December 2023",
      title: "A quick-start guide on hosting Next.js on Upsun",
      authors: [
        {name: "Florent Huck"},
      ],
      cover_image: {
        localFile: {
          childImageSharp: {
            gatsbyImageData: getGatsbyImage(customCover)
          }
        }
      }
    }
  };
  
  filteredPosts = [customPosts, ...filteredPosts];
  
  filteredPosts = filteredPosts.sort((a, b) => {
    return new Date(b.node.publishedAt) - new Date(a.node.publishedAt);
  });

  //To avoid the box-shadows from cards overflowing the container
  const gridPadding = css`
    padding-left: ${pxToRem(2)};
    padding-right: ${pxToRem(2)};
  `;

  return (
    <Layout>
      <GridContainer css={gridPadding}>
        <GridCol colStart={1} colEnd={13}>
          <Heading level={1} text={"Blog"} css={headingStyles} />
        </GridCol>
        {filteredPosts.map((post) => {
          const coverImage = post?.node?.cover_image?.localFile?.childImageSharp
            ?.gatsbyImageData as IGatsbyImageData;
          const author = post?.node?.authors?.at(0)?.name;
          return (
            <GridCol
              key={post?.node?.id}
              colStart={1}
              colEnd={13}
              colStartSm={"auto"}
              colEndSm={"span 6"}
              colEndLg={"span 4"}
              colEndXl={"span 3"}
              css={margin}
            >
              <Card
                title={post?.node?.title || ""}
                author={author || ""}
                image={coverImage}
                href={`/blog/${post?.node?.url}`}
                date={post?.node?.publishedAt}
                altText=""
              />
            </GridCol>
          );
        })}
      </GridContainer>
    </Layout>
  );
};

export const query = graphql`
  query allStrapiBlogPostQuery {
    allStrapiBlogPost {
      edges {
        node {
          id
          cover_image {
            localFile {
              childImageSharp {
                gatsbyImageData(quality: 90)
              }
              publicURL
            }
          }
          title
          url
          publishedAt(formatString: "DD MMMM YYYY")
          authors {
            name
            job_title
            company
          }
        }
      }
    }
  }
`;

export default BlogPage;

export const Head: HeadFC = ({ location }) => (
  <SEO
    title={"Upsun blog | Upsun"}
    description={
      "Written for developers, by developers: discover the latest updates and learn more about Platforms-as-a-Service, Upsun, the cloud, and much more on our blog."
    }
    pathname={location.pathname}
  />
);
